import { Directive, HostListener } from '@angular/core';

// Prevents starting with a space on any input
@Directive({
  selector: '[appNoLeadingSpace]'
})
export class NoLeadingSpaceDirective {
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    if (event.key === ' ' && (!input.value || input.selectionStart === 0)) {
      event.preventDefault();
    }
  }
}

// Allows numbers only (Mobile, Pincode, Bank Account)
@Directive({
  selector: '[appNumbersOnly]'
})
export class NumbersOnlyDirective {
  private allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.allowedKeys.includes(event.key)) return;
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }
}